export enum ConfirmCountryStorage {
    MODAL_DISMISSED_KEY = "confirmCountry.modal_dismissed_key",
}
